export const SupportedChainId = {
    MAINNET: 1,
    RINKEBY: 4,
    GOERLI:5,
    POLYGON: 137
}